export const appsTransformationsDatatable = "/apps/transformations_datatable";
